import { QueryLoader } from "@Light/components/app/QueryLoader";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { DetailField } from "@Light/components/page/detail/DetailField";
import { useHeaderBackNavigate } from "@Light/components/page/header/context";
import { Hyperlink } from "@Light/components/page/Hyperlink";
import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import dayjs from "dayjs";
import { CardDescription, useInvoiceLink } from "./common";
import { useInvoice } from "./context";

export type PaymentConfirmedProps = {
  hideBack?: boolean;
};

export const PaymentConfirmed: React.FC<PaymentConfirmedProps> = ({
  hideBack,
}) => {
  const { invoice } = useInvoice();
  const invoiceLink = useInvoiceLink(invoice);
  useHeaderBackNavigate(hideBack ? undefined : invoiceLink);

  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Link = scaffold.system.link;
  if (!invoice.paid_at) {
    return <QueryLoader />;
  }
  return (
    <PageBody
      title="Thank you for your payment"
      subtitle={<>You've made a payment for invoice #{invoice.number}</>}
      footer={
        <ButtonFooter>
          <Link to={invoiceLink} className="w-full">
            <Button size="lg" className="w-full">
              Return
            </Button>
          </Link>
        </ButtonFooter>
      }
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-4">
          <DetailField label="Amount">${invoice.total}</DetailField>
          <DetailField label="Payment date">
            {dayjs(invoice.paid_at).format("MMM D, YYYY, hh:mm:ss A")}
          </DetailField>
          <DetailField label="Payment method">
            <CardDescription />
          </DetailField>
        </div>
        <div className={clsx("text-sm", scaffold.page.colors.text.secondary)}>
          If you have any questions, email us at{" "}
          <Hyperlink href={`email:${scaffold.page.supportEmail}`}>
            {scaffold.page.supportEmail}
          </Hyperlink>{" "}
          or call us at{" "}
          <Hyperlink href={`tel:${scaffold.page.supportPhone}`}>
            {scaffold.page.supportPhone}
          </Hyperlink>
          .
        </div>
      </div>
    </PageBody>
  );
};
